import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

import { ChakraProvider } from "@chakra-ui/react";

import theme from "./theme";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
